export const EstadoProcesoEnvio = Object.freeze({
    REGISTRADO: "REGISTRADO",
    PENDIENTE_NOTIFICAR: "PENDIENTE_NOTIFICAR",
    EN_CURSO: "EN_CURSO",
    COMPLETADO: "COMPLETADO"
});
